import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/">
          <img className="logo" src="/assets/livad-logo.png" alt="LIVAD" />
        </Link>

        <button
          className={`hamburger-menu ${isMenuOpen ? "open" : ""}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`header-right ${isMenuOpen ? "open" : ""}`}>
          <Link
            to="https://www.livadstream.com/streamers"
            onClick={() => setIsMenuOpen(false)}
          >
            Streamers
          </Link>
          <Link
            to="https://www.livadstream.com/brands"
            onClick={() => setIsMenuOpen(false)}
          >
            Brands
          </Link>
          <Link to="/" className="active" onClick={() => setIsMenuOpen(false)}>
            Blog
          </Link>
          <div className="cta-buttons">
            <Link
              to="https://streamer.livad.stream"
              className="cta-button"
              onClick={() => setIsMenuOpen(false)}
            >
              SIGN UP
            </Link>
            <Link
              to="https://www.livadstream.com/contact"
              className="cta-button"
              onClick={() => setIsMenuOpen(false)}
            >
              REQUEST A DEMO
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
